import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IApartmentListingViewModel } from '../../../../models/apartment';

@Component
class BlockApartmentsItem extends Vue {

  get lblSetting() {
    return {
      ...require('@/locales/block').default
    }
  }

  @Prop({ required: true, type: [Object] })
  source: IApartmentListingViewModel;

  get apartment() {
    return this.source.apartment;
  }
  get redirectTo() {
    return {
      path: `/block/${this.source.id}/apartment/${this.source.apartment.id}`,
      params: { cid: this.source.apartment.id, id: this.source.id },
      query: {
        name: this.source.apartment.apartment_number
      }
    }
  }
}

export default BlockApartmentsItem;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-apartment-item/index.ts